import React, { useContext } from "react";
import { JointBillContext } from "@features/JointBillList/utils";
import { type IJointBillServicePeriodVoucher } from "@services/overview/types";
import { JointBillVoucherActiveBillDisplay } from "./components/JointBIllVoucherActiveBillDisplay";
import { JointBillVoucherArchiveDisplay } from "./components/JointBillVoucherArchiveDisplay";

interface IJointBillVoucherProps {
  totalExpectedPayment?: number;
  totalSum?: number;
  vouchers?: IJointBillServicePeriodVoucher[];
  jointBillServiceId: number;
}

export const JointBillVoucher: React.FC<IJointBillVoucherProps> = ({
  totalExpectedPayment = 0,
  totalSum = 0,
  vouchers,
  jointBillServiceId,
}) => {
  const { isArchiveMode } = useContext(JointBillContext);
  const hasVoucher = (vouchers?.length ?? 0) > 0;

  if (isArchiveMode && !hasVoucher) {
    return null;
  }

  return (
    <div className="group contents">
      <div className="col-start-0 md:col-start-0 col-end-[span_3] flex w-full justify-end p-6 pb-0 md:col-end-[span_4] md:pl-0">
        <div className="flex w-full max-w-[35rem] flex-col rounded-2xl border border-grey-light p-[1.2rem]">
          {!isArchiveMode && (
            <JointBillVoucherActiveBillDisplay
              totalExpectedPayment={totalExpectedPayment}
              vouchers={vouchers}
              jointBillServiceId={jointBillServiceId}
            />
          )}
          {isArchiveMode && (
            <JointBillVoucherArchiveDisplay
              totalSum={totalSum}
              vouchers={vouchers!}
            />
          )}
        </div>
      </div>
    </div>
  );
};
